import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import "./PromptCard.scss";

const PromptCard = (props) => {
	const { text, ctaText, onClick, className } = props;

	const classes = {
		"prompt-card": true,
		[className]: className,
	};

	return (
		<button className={classnames(classes)} onClick={onClick}>
			<div className="blank-row blank-row--gray">
				<div className="prompt-card-content">
					<span className="prompt-card-text">
						{text}
					</span>
					<span className="prompt-card-iconline">
						<span className="prompt-card-iconline-icon" />
						{ctaText}
					</span>
				</div>
			</div>
		</button>
	);
};

PromptCard.propTypes = {
	text: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
	]).isRequired,
	ctaText: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.object,
	]).isRequired,
	onClick: PropTypes.func.isRequired,
	className: PropTypes.string,
};

export default PromptCard;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/PromptCard.jsx